// Die Übernahme anstoßen -- auf jeder Seite, sobald eine Sitzung da ist.
//
// Der Trichter endet erst hier: ohne diesen Schritt hätte jemand ohne Konto
// vektorisiert, sein Ergebnis gesehen, sich registriert -- und stünde in einem
// leeren Dashboard, während seine Arbeit weiter im Browser läge. Deshalb auf
// *jeder* Seite und nicht nur auf der Dashboard-Seite: registriert wird auf
// `/users/sign_up`, bestätigt wird über einen Mail-Link, angemeldet wird auf
// `/users/sign_in` -- welche Seite danach kommt, entscheidet Devise, nicht wir.
//
// Erkannt wird die Sitzung an `<meta name="current-user-id">`, das das Layout
// für jedes angemeldete Konto rendert (es steht dort schon für den
// Kontowechsel-Guard des Service-Workers). Ohne den Tag passiert hier nichts,
// und ohne ein Ergebnis in der IndexedDB auch nicht -- der Normalfall kostet
// einen Blick in einen leeren Speicher.
//
// Der Speicher kommt per `import()` und nicht statisch: `editor/guestResult`
// und dahinter `editor/indexedDb` teilen sich mit verschiedenen nachgeladenen
// Chunks (/ausprobieren, Editor, Dashboard), und eine solche Kette am
// Einstiegsbündel legt rolldown je nach Modulreihenfolge als eigenes Skript
// neben das Bündel -- die Startseite lüde dann zwei (e2e/code-splitting.spec.ts,
// ausführlicher in lib/guestTrace.ts). Für ein angemeldetes Konto ist das
// eine kleine, gehashte und vom Service-Worker gecachte Datei pro Seite; für
// jeden Gast nichts.

import type { GuestResult } from '../editor/guestResult'
import { apiSendForm } from './api'
import { importGuestResults, type ImportedProject } from './guestImport'

function signedIn(): boolean {
  return document.querySelector('meta[name="current-user-id"]') !== null
}

async function send(result: GuestResult): Promise<ImportedProject> {
  const form = new FormData()
  form.append('key', result.key)
  form.append('name', result.name)
  form.append('document', JSON.stringify(result.document))
  if (result.image) form.append('image', result.image, result.imageName ?? 'gast.png')

  return apiSendForm<ImportedProject>('/api/v1/guest/imports', form)
}

export function startGuestImport(): void {
  if (!signedIn()) return

  // Ohne `await` und ohne die Seite aufzuhalten: das Ergebnis liegt gleich im
  // Dashboard, auch wenn diese Runde erst nach dem Rendern fertig wird. Ein
  // Fehlschlag ist kein Drama -- `importGuestResults` lässt den Eintrag
  // stehen, und der nächste Seitenaufruf versucht es noch einmal.
  void import('../editor/guestResult')
    .then(({ defaultGuestResultStorage }) => {
      const storage = defaultGuestResultStorage()
      if (storage === null) return
      return importGuestResults(storage, send)
    })
    .catch((error: unknown) => {
      console.warn('The guest result could not be imported', error)
    })
}
